import { PostTabs } from './PostTabs'
import type { PostTab } from './PostTabs'
import { PostTabsDropdown } from './PostTabsDropdown'
import type { TabConfig } from './types'

import styles from './PostTabsResponsive.module.css'

import type { JSX } from 'react'

type PostTabsResponsiveProps = {
  tabs: TabConfig[]
  value: PostTab
  onChange: (tab: PostTab) => void
  countLimit?: number | null
  countLoading?: boolean
}

/**
 * Responsive wrapper for PostTabs that automatically switches between
 * TabList (desktop) and Dropdown (mobile) based on container width.
 *
 * Uses CSS container queries on the `page-header` container.
 * Tabs collapse into a dropdown below 600px.
 */
export function PostTabsResponsive({
  tabs,
  value,
  onChange,
  countLimit,
  countLoading = false,
}: PostTabsResponsiveProps): JSX.Element {
  return (
    <>
      <div className={styles.dropdownContainer}>
        <PostTabsDropdown
          tabs={tabs}
          value={value}
          onChange={onChange}
          countLimit={countLimit}
          countLoading={countLoading}
        />
      </div>
      <div className={styles.tabListContainer}>
        <PostTabs.TabList>
          {tabs.map((tab) => (
            <PostTabs.Tab
              key={tab.id}
              value={tab.id}
              count={tab.count}
              countLimit={countLimit}
              countLoading={countLoading}
            />
          ))}
        </PostTabs.TabList>
      </div>
    </>
  )
}
